import { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Modal } from '../../../components/Modal';
import { useParamsContext } from '../../../contexts/ParamsContext';
import AgendaSettings from './settings/Settings';
import { AgendaEstabelecimentoList } from './list/List';
import { AgendaForm } from './Form/Form';
import { useTour } from '../../../contexts/TourContext';
import { tour } from './tour';
import QuickHorariosModal from './quick/QuickHorariosModal';

// Mesmo limite do Modal, que abaixo dele ocupa a tela inteira e cobre o cabecalho do app.
const MOBILE_MAX_WIDTH = 640;

const Agenda = () => {
    const { action, clear } = useParamsContext();
    const { startTour } = useTour();
    const isMobile = useMediaQuery({ maxWidth: MOBILE_MAX_WIDTH });
    const [listVersion, setListVersion] = useState(0);
    const previousAction = useRef(action);

    const handleStartTour = () => {
        startTour(tour);
    };

    // A agenda fica montada atras da configuracao e usa os horarios dela: recarrega ao sair, por qualquer caminho.
    useEffect(() => {
        if (previousAction.current === 'settings' && action !== 'settings') {
            setListVersion((value) => value + 1);
        }
        previousAction.current = action;
    }, [action]);

    if (action === 'quick-hours') {
        return (
            <div className="pb-10">
                <AgendaEstabelecimentoList />
                <QuickHorariosModal />
            </div>
        );
    }

    if (!isMobile) {
        if (action === 'settings') return <div className="pb-10"><AgendaSettings /></div>;
        if (action === 'add') return <div className="pb-10"><AgendaForm /></div>;
    }

    // A agenda continua montada atras do que abrir por cima, preservando dia e rolagem ao voltar.
    return (
        <>
            {/* Ao salvar, recarrega a agenda: ela nao desmonta, e o aviso em tempo real pode falhar. */}
            <AgendaEstabelecimentoList key={listVersion} />
            {action === 'add' && <AgendaForm mobileSheet onDone={() => setListVersion((value) => value + 1)} />}
            {action === 'settings' && (
                <Modal title="Configurações da agenda" onClose={clear} panelClassName="sf-page-sheet">
                    <AgendaSettings inSheet />
                </Modal>
            )}
        </>
    );
};

export default Agenda;
